import { createContext, useContext } from 'react'

import { AnyRouter, RouteApi } from '@tanstack/react-router'
import { DocTemplateDetails } from '~bank-document-templates/types'

type TemplatesDetailsContextValue = {
  routeApi: RouteApi<'/_app/document-templates/$id', AnyRouter>
  data: DocTemplateDetails
}

export const TemplatesDetailsContext = createContext<TemplatesDetailsContextValue | undefined>(undefined)

export const useTemplatesDetailsContext = () => {
  const context = useContext(TemplatesDetailsContext)
  if (!context) {
    throw new Error('useTemplatesDetailsContext must be used within a TemplatesDetailsContext.Provider')
  }
  return context
}
